import React, { useState } from 'react';
import Header from '../../components/Header';
import { Aside } from '../../components/Aside';
import Dash from '../../components/Dash';
import { GlobalStyle } from '../../styles/global';
import Modal from '../../components/Modal';

const Dashboard: React.FC = () => {

  const [showmodal, setShowmodal] = useState(false);
  const [datamodal] = useState({})
  const [updateCiclo, setUpdateciclo] = useState(false);  

  return (
    <>
        <Modal 
          show={showmodal} 
          setShowmodal={() => 
          setShowmodal(!showmodal)} 
          datamodal={datamodal} 
          setUpdateciclo={() => setUpdateciclo(!updateCiclo) } 
        />
        <Header />
        <Aside />
        <Dash/>
        <GlobalStyle />
    </>
   );
}

export default Dashboard;